import React from "react";
import { EditStyleWrapper } from "./styles";
import EditIcon from "@mui/icons-material/Edit";
import { setSelectedField } from "../../../store/slices/invitations/invitations.slice";
import { useAppDispatch } from "../../../store";

const EditWrapper = ({
	children,
	canEdit,
	isActive,
	dataId
}: {
	children: React.ReactNode;
	canEdit: boolean;
	isActive?: boolean;
	dataId?: string;
}) => {
	const dispatch = useAppDispatch();

	const handleClickInput = () => {
		if (dataId) {
			dispatch(setSelectedField(dataId));
		}
	};
	return (
		<EditStyleWrapper $canEdit={canEdit} $isActive={isActive} onClick={handleClickInput}>
			<EditIcon className={"editIcon"} />
			{children}
		</EditStyleWrapper>
	);
};

export default EditWrapper;
